import { render, staticRenderFns } from "./ServiceHistory.vue?vue&type=template&id=3ec6716e"
import script from "./ServiceHistory.vue?vue&type=script&lang=js"
export * from "./ServiceHistory.vue?vue&type=script&lang=js"
import style0 from "./ServiceHistory.vue?vue&type=style&index=0&id=3ec6716e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports